import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';
import { NavItem } from '@core/services/menu/menu.service';

@Component({
  selector: 'Teranet-UserItem',
  templateUrl: './user-item.component.html',
})
export class UserItemComponent implements OnInit {
  @Input() navItem: NavItem[];
  @Input() notificationBadges: number;

  notificationMenu: NavItem = null;
  userName: string = '';

  constructor(
    public authService: AuthService,
    private dialog: MatDialog,
    private router: Router
  ) {
    this.authService.currentUserSubject.subscribe(data => {
      if (data) {
        this.userName = data.username;
      }
    });
  }

  ngOnInit() {
    if (this.navItem && this.navItem.length > 0) {
      this.notificationMenu = this.navItem.find(n => n.route === 'notification');
    }
    this.userName = this.authService.currentUserValue
      ? this.authService.currentUserValue.username.trim()
      : '';
  }

  logout() {
    this.authService.revokeToken();
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  changePassword() {
    this.router.navigate(['/updatepassword']);
  }



  passwordSecurity() {
    this.router.navigate(['/passwordsecurity'], { queryParams: { isChangePasswordForced: false } });
  }

  userManual() {
    window.open('#/usermanual', '_blank');
  }

  userProfile() {
    this.router.navigate(['/userprofile']);
  }
}
